// @flow

export default {
  // comments and discussions
  openFlagModal(state: State, id: number) {
    state.flagModal = { active: true, id }
  },
  closeFlagModal(state: State) {
    state.flagModal = { active: false, id: -1 }
  },

  // this is just for comments
  openDeleteConfirmationModal(state: State, id: number) {
    state.deleteConfirmationModal = { active: true, id }
  },

  closeDeleteConfirmationModal(state: State) {
    state.deleteConfirmationModal = { active: false, id: -1 }
  },

  setUser(state: State, user: $Shape<User>) {
    state.user = {
      ...state.user,
      ...user,
    }
  },

  // Really article is a Discussion
  setArticle(state: State, article: $Shape<Article>) {
    state.article = {
      ...state.article,
      ...article,
    }
  },

  // currently these toggles are just discussions and use the state article object.
  // Comments use toggleCommentLik
  setLike(state: State, isLiked: boolean) {
    state.article.isLiked = isLiked
  },
  increaseLikeCount(state: State) {
    state.article.likeCount++
  },
  decreaseLikeCount(state: State) {
    state.article.likeCount--
  },

  setUserLoggedOut(state: State) {
    state.user = {
      avatar: '',
      displayName: 'Guest',
      firstName: 'guest',
      username: 'guest',
    }
  },

  setErrorModalIsActive(state: State, isActive: boolean) {
    state.errorModal.active = isActive
  },

  setLoginModalIsActive(state: State, isActive: boolean) {
    state.loginModal.active = isActive
  },

  setRefreshScheduledInstances(state: State, refresh: boolean) {
    state.refreshScheduledInstances = refresh
  },
}
